/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, n: NonNullable<unknown> }} Window_LastInputs */



/**
* | output |
* | --- |
* | "last {days} days" |
*
* @param {Window_LastInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const window_last = /** @type {((inputs: Window_LastInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_LastInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`последний ${i?.days} день`);
		if (form === "few") return /** @type {LocalizedString} */ (`последние ${i?.days} дня`);
		if (form === "many") return /** @type {LocalizedString} */ (`последние ${i?.days} дней`);
		return /** @type {LocalizedString} */ (`последние ${i?.days} дня`)
	}
	return /** @type {LocalizedString} */ (`last ${i?.days} days`)
});